/* eslint-disable max-len */
import React from "react"

import theme from "@irati/ui/src/global/theme"

import BaseSvgIcon from "../Base"

const Globe = (props) => {
  return (
    <BaseSvgIcon fill={theme.colors.greys.white} {...props} viewBox="0 0 30 30">
      <g>
        <path
          d="M15 26.25C21.2132 26.25 26.25 21.2132 26.25 15C26.25 8.7868 21.2132 3.75 15 3.75C8.7868 3.75 3.75 8.7868 3.75 15C3.75 21.2132 8.7868 26.25 15 26.25Z"
          stroke="#21295C"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.1017 19.9688L18.7384 16.0547C18.6289 15.9843 18.5046 15.9401 18.3751 15.9258L15.6915 15.5625C15.4913 15.5338 15.2872 15.5722 15.1112 15.6719C14.9352 15.7716 14.7972 15.9268 14.7189 16.1133L13.1134 19.7109C13.0379 19.8783 13.0133 20.0641 13.0424 20.2453C13.0716 20.4266 13.1533 20.5953 13.2775 20.7305L15.4806 23.1094C15.5802 23.2188 15.6532 23.3498 15.6938 23.4921C15.7345 23.6344 15.7417 23.7841 15.715 23.9297L15.258 26.25"
          stroke="#21295C"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.61724 6.51562L6.56255 9C6.47068 9.22056 6.46649 9.46786 6.55083 9.69141L7.89849 13.2773C7.95116 13.4268 8.04131 13.5602 8.16032 13.6649C8.27932 13.7695 8.4232 13.8419 8.57817 13.875L11.086 14.4141C11.2252 14.4422 11.3559 14.5024 11.4678 14.5899C11.5797 14.6773 11.6696 14.7897 11.7305 14.918L12.1758 15.8437C12.255 16.0003 12.3754 16.1322 12.5241 16.2251C12.6729 16.3181 12.8442 16.3686 13.0196 16.3711H14.6016"
          stroke="#21295C"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.8711 4.11328L18.9609 6.08203C19.0616 6.26712 19.0977 6.48043 19.0638 6.68835C19.0299 6.89627 18.9277 7.08699 18.7734 7.23047L15.6211 10.0781C15.5683 10.1285 15.5092 10.1718 15.4453 10.207L14.0039 11.0039C13.8665 11.0768 13.7141 11.1169 13.5586 11.1211H11.0508C10.866 11.122 10.6856 11.1769 10.5315 11.2789C10.3775 11.3809 10.2566 11.5256 10.1836 11.6953L9.21094 14.0039"
          stroke="#21295C"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </BaseSvgIcon>
  )
}

export default Globe
